'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = require('./assert');

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');
      var event = this._eventOrExtractFromEvents(eventOrKey, eventOrUndefined);

      var validatorsResult = this._validators.length > 0 ? this._validators.some(function (validator) {
        return validator.match(event) && (validator.execute(event) || true);
      }) : true;

      if (!validatorsResult) {
        throw new Error('No validator accepted the event');
      }

      return Promise.all(this._publishers.map(function (publish) {
        var cloned = Object.assign({}, _this._defaults, event);
        return BiLogger._withCatch(function () {
          return Promise.resolve().then(function () {
            return publish(cloned, _this._context);
          });
        }).catch(function (err) {
          return Promise.reject(new Error('Publisher \'' + publish.name + '\' failed with error: \'' + err.message + '\''));
        });
      }));
    }
  }, {
    key: '_eventOrExtractFromEvents',
    value: function _eventOrExtractFromEvents(eventOrKey, eventOrUndefined) {
      if (typeof eventOrKey === 'string') {
        var event = this._events[eventOrKey];
        if (!event) {
          throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
        }

        if (eventOrUndefined) {
          return Object.assign({}, event, eventOrUndefined);
        } else {
          return event;
        }
      } else {
        return eventOrKey;
      }
    }
  }], [{
    key: '_withCatch',
    value: function _withCatch(fn) {
      try {
        return fn();
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map


//////////////////
// WEBPACK FOOTER
// ../~/wix-bi-logger-client/dist/bi-logger.js
// module id = 869
// module chunks = 0